// Initial list of reciters as fallback
export const fallbackReciters = [
    { identifier: "ar.alafasy", englishName: "Mishary Rashid Alafasy" },
    { identifier: "ar.abdulbasitmurattal", englishName: "Abdul Basit" },
    { identifier: "ar.abdurrahmaansudais", englishName: "Abdurrahmaan As-Sudais" },
    { identifier: "ar.shaatree", englishName: "Abu Bakr Ash-Shaatree" },
    { identifier: "ar.ahmedajamy", englishName: "Ahmed Al-Ajamy" }
  ];
  
  // Initial translation options as fallback
  export const fallbackTranslations = [
    { identifier: "en.asad", englishName: "Muhammad Asad", language: "en" },
    { identifier: "en.pickthall", englishName: "Pickthall", language: "en" }
  ];
  
// Quran data structure with all 114 surahs
export const quranStructure = [
  { number: 1, name: "Al-Fatihah", englishName: "The Opening", totalVerses: 7 },
  { number: 2, name: "Al-Baqarah", englishName: "The Cow", totalVerses: 286 },
  { number: 3, name: "Ali 'Imran", englishName: "Family of Imran", totalVerses: 200 },
  { number: 4, name: "An-Nisa", englishName: "The Women", totalVerses: 176 },
  { number: 5, name: "Al-Ma'idah", englishName: "The Table Spread", totalVerses: 120 },
  { number: 6, name: "Al-An'am", englishName: "The Cattle", totalVerses: 165 },
  { number: 7, name: "Al-A'raf", englishName: "The Heights", totalVerses: 206 },
  { number: 8, name: "Al-Anfal", englishName: "The Spoils of War", totalVerses: 75 },
  { number: 9, name: "At-Tawbah", englishName: "The Repentance", totalVerses: 129 },
  { number: 10, name: "Yunus", englishName: "Jonah", totalVerses: 109 },
  { number: 11, name: "Hud", englishName: "Hud", totalVerses: 123 },
  { number: 12, name: "Yusuf", englishName: "Joseph", totalVerses: 111 },
  { number: 13, name: "Ar-Ra'd", englishName: "The Thunder", totalVerses: 43 },
  { number: 14, name: "Ibrahim", englishName: "Abraham", totalVerses: 52 },
  { number: 15, name: "Al-Hijr", englishName: "The Rocky Tract", totalVerses: 99 },
  { number: 16, name: "An-Nahl", englishName: "The Bee", totalVerses: 128 },
  { number: 17, name: "Al-Isra", englishName: "The Night Journey", totalVerses: 111 },
  { number: 18, name: "Al-Kahf", englishName: "The Cave", totalVerses: 110 },
  { number: 19, name: "Maryam", englishName: "Mary", totalVerses: 98 },
  { number: 20, name: "Ta-Ha", englishName: "Ta-Ha", totalVerses: 135 },
  { number: 21, name: "Al-Anbiya", englishName: "The Prophets", totalVerses: 112 },
  { number: 22, name: "Al-Hajj", englishName: "The Pilgrimage", totalVerses: 78 },
  { number: 23, name: "Al-Mu'minun", englishName: "The Believers", totalVerses: 118 },
  { number: 24, name: "An-Nur", englishName: "The Light", totalVerses: 64 },
  { number: 25, name: "Al-Furqan", englishName: "The Criterion", totalVerses: 77 },
  { number: 26, name: "Ash-Shu'ara", englishName: "The Poets", totalVerses: 227 },
  { number: 27, name: "An-Naml", englishName: "The Ant", totalVerses: 93 },
  { number: 28, name: "Al-Qasas", englishName: "The Stories", totalVerses: 88 },
  { number: 29, name: "Al-Ankabut", englishName: "The Spider", totalVerses: 69 },
  { number: 30, name: "Ar-Rum", englishName: "The Romans", totalVerses: 60 },
  { number: 31, name: "Luqman", englishName: "Luqman", totalVerses: 34 },
  { number: 32, name: "As-Sajdah", englishName: "The Prostration", totalVerses: 30 },
  { number: 33, name: "Al-Ahzab", englishName: "The Combined Forces", totalVerses: 73 },
  { number: 34, name: "Saba", englishName: "Sheba", totalVerses: 54 },
  { number: 35, name: "Fatir", englishName: "Originator", totalVerses: 45 },
  { number: 36, name: "Ya-Sin", englishName: "Ya Sin", totalVerses: 83 },
  { number: 37, name: "As-Saffat", englishName: "Those who set the Ranks", totalVerses: 182 },
  { number: 38, name: "Sad", englishName: "The Letter Sad", totalVerses: 88 },
  { number: 39, name: "Az-Zumar", englishName: "The Troops", totalVerses: 75 },
  { number: 40, name: "Ghafir", englishName: "The Forgiver", totalVerses: 85 },
  { number: 41, name: "Fussilat", englishName: "Explained in Detail", totalVerses: 54 },
  { number: 42, name: "Ash-Shura", englishName: "The Consultation", totalVerses: 53 },
  { number: 43, name: "Az-Zukhruf", englishName: "The Ornaments of Gold", totalVerses: 89 },
  { number: 44, name: "Ad-Dukhan", englishName: "The Smoke", totalVerses: 59 },
  { number: 45, name: "Al-Jathiyah", englishName: "The Crouching", totalVerses: 37 },
  { number: 46, name: "Al-Ahqaf", englishName: "The Wind-Curved Sandhills", totalVerses: 35 },
  { number: 47, name: "Muhammad", englishName: "Muhammad", totalVerses: 38 },
  { number: 48, name: "Al-Fath", englishName: "The Victory", totalVerses: 29 },
  { number: 49, name: "Al-Hujurat", englishName: "The Rooms", totalVerses: 18 },
  { number: 50, name: "Qaf", englishName: "The Letter Qaf", totalVerses: 45 },
  { number: 51, name: "Adh-Dhariyat", englishName: "The Winnowing Winds", totalVerses: 60 },
  { number: 52, name: "At-Tur", englishName: "The Mount", totalVerses: 49 },
  { number: 53, name: "An-Najm", englishName: "The Star", totalVerses: 62 },
  { number: 54, name: "Al-Qamar", englishName: "The Moon", totalVerses: 55 },
  { number: 55, name: "Ar-Rahman", englishName: "The Beneficent", totalVerses: 78 },
  { number: 56, name: "Al-Waqi'ah", englishName: "The Inevitable", totalVerses: 96 },
  { number: 57, name: "Al-Hadid", englishName: "The Iron", totalVerses: 29 },
  { number: 58, name: "Al-Mujadila", englishName: "The Pleading Woman", totalVerses: 22 },
  { number: 59, name: "Al-Hashr", englishName: "The Exile", totalVerses: 24 },
  { number: 60, name: "Al-Mumtahanah", englishName: "She that is to be examined", totalVerses: 13 },
  { number: 61, name: "As-Saff", englishName: "The Ranks", totalVerses: 14 },
  { number: 62, name: "Al-Jumu'ah", englishName: "Friday", totalVerses: 11 },
  { number: 63, name: "Al-Munafiqun", englishName: "The Hypocrites", totalVerses: 11 },
  { number: 64, name: "At-Taghabun", englishName: "Mutual Disillusion", totalVerses: 18 },
  { number: 65, name: "At-Talaq", englishName: "Divorce", totalVerses: 12 },
  { number: 66, name: "At-Tahrim", englishName: "Prohibition", totalVerses: 12 },
  { number: 67, name: "Al-Mulk", englishName: "The Sovereignty", totalVerses: 30 },
  { number: 68, name: "Al-Qalam", englishName: "The Pen", totalVerses: 52 },
  { number: 69, name: "Al-Haqqah", englishName: "The Reality", totalVerses: 52 },
  { number: 70, name: "Al-Ma'arij", englishName: "The Ascending Stairways", totalVerses: 44 },
  { number: 71, name: "Nuh", englishName: "Noah", totalVerses: 28 },
  { number: 72, name: "Al-Jinn", englishName: "The Jinn", totalVerses: 28 },
  { number: 73, name: "Al-Muzzammil", englishName: "The Enshrouded One", totalVerses: 20 },
  { number: 74, name: "Al-Muddathir", englishName: "The Cloaked One", totalVerses: 56 },
  { number: 75, name: "Al-Qiyamah", englishName: "The Resurrection", totalVerses: 40 },
  { number: 76, name: "Al-Insan", englishName: "Man", totalVerses: 31 },
  { number: 77, name: "Al-Mursalat", englishName: "The Emissaries", totalVerses: 50 },
  { number: 78, name: "An-Naba", englishName: "The Tidings", totalVerses: 40 },
  { number: 79, name: "An-Nazi'at", englishName: "Those who drag forth", totalVerses: 46 },
  { number: 80, name: "Abasa", englishName: "He frowned", totalVerses: 42 },
  { number: 81, name: "At-Takwir", englishName: "The Overthrowing", totalVerses: 29 },
  { number: 82, name: "Al-Infitar", englishName: "The Cleaving", totalVerses: 19 },
  { number: 83, name: "Al-Mutaffifin", englishName: "Defrauding", totalVerses: 36 },
  { number: 84, name: "Al-Inshiqaq", englishName: "The Sundering", totalVerses: 25 },
  { number: 85, name: "Al-Buruj", englishName: "The Mansions of the Stars", totalVerses: 22 },
  { number: 86, name: "At-Tariq", englishName: "The Morning Star", totalVerses: 17 },
  { number: 87, name: "Al-A'la", englishName: "The Most High", totalVerses: 19 },
  { number: 88, name: "Al-Ghashiyah", englishName: "The Overwhelming", totalVerses: 26 },
  { number: 89, name: "Al-Fajr", englishName: "The Dawn", totalVerses: 30 },
  { number: 90, name: "Al-Balad", englishName: "The City", totalVerses: 20 },
  { number: 91, name: "Ash-Shams", englishName: "The Sun", totalVerses: 15 },
  { number: 92, name: "Al-Layl", englishName: "The Night", totalVerses: 21 },
  { number: 93, name: "Ad-Duha", englishName: "The Morning Hours", totalVerses: 11 },
  { number: 94, name: "Ash-Sharh", englishName: "The Relief", totalVerses: 8 },
  { number: 95, name: "At-Tin", englishName: "The Fig", totalVerses: 8 },
  { number: 96, name: "Al-Alaq", englishName: "The Clot", totalVerses: 19 },
  { number: 97, name: "Al-Qadr", englishName: "The Power", totalVerses: 5 },
  { number: 98, name: "Al-Bayyinah", englishName: "The Clear Proof", totalVerses: 8 },
  { number: 99, name: "Az-Zalzalah", englishName: "The Earthquake", totalVerses: 8 },
  { number: 100, name: "Al-Adiyat", englishName: "The Courser", totalVerses: 11 },
  { number: 101, name: "Al-Qari'ah", englishName: "The Calamity", totalVerses: 11 },
  { number: 102, name: "At-Takathur", englishName: "Rivalry in world increase", totalVerses: 8 },
  { number: 103, name: "Al-Asr", englishName: "The Declining Day", totalVerses: 3 },
  { number: 104, name: "Al-Humazah", englishName: "The Traducer", totalVerses: 9 },
  { number: 105, name: "Al-Fil", englishName: "The Elephant", totalVerses: 5 },
  { number: 106, name: "Quraysh", englishName: "Quraysh", totalVerses: 4 },
  { number: 107, name: "Al-Ma'un", englishName: "Small Kindnesses", totalVerses: 7 },
  { number: 108, name: "Al-Kawthar", englishName: "Abundance", totalVerses: 3 },
  { number: 109, name: "Al-Kafirun", englishName: "The Disbelievers", totalVerses: 6 },
  { number: 110, name: "An-Nasr", englishName: "Divine Support", totalVerses: 3 },
  { number: 111, name: "Al-Masad", englishName: "The Palm Fiber", totalVerses: 5 },
  { number: 112, name: "Al-Ikhlas", englishName: "Sincerity", totalVerses: 4 },
  { number: 113, name: "Al-Falaq", englishName: "The Daybreak", totalVerses: 5 },
  { number: 114, name: "An-Nas", englishName: "Mankind", totalVerses: 6 }
];
  
  // Total number of verses in the Quran
  export const TOTAL_QURAN_VERSES = 6236;
  
  // Storage keys
  export const STORAGE_KEYS = {
    PROGRESS: 'quranReaderProgress'
  };
  
  // API URLs
  export const API_URLS = {
    EDITIONS: 'https://api.alquran.cloud/v1/edition',
    VERSE: 'https://api.alquran.cloud/v1/ayah'
  };